import React from "react";
import { connect } from "react-redux";
import { number, string, bool, func, object } from "prop-types";
import jwtDecode from "jwt-decode";
import Loader from "react-loader-advanced";
import { ThreeBounce } from "better-react-spinkit";
import queryString from "query-string";
import Helmet from "react-helmet";
import { OverlayTrigger, Popover, Col, Row, Button } from "react-bootstrap";
import { getCookieValue, getSubDomain } from "utils/helperFunctions";
import CriteriaLogo from "resources/images/criteriaLogo_dashboard_NA.png";
import CriteriaBlueLogo from "resources/images/criteriaLogo_dashboard_APAC.png";
import CriteriaBlueLogoSmall from "resources/images/criteriaLogo_dashboard_mobile.png";
import { ssoLogin, authorizeLinkedInIntegration } from "../actions";
import LoginForm from "./LoginForm";
import RegionSelectModal from "./RegionSelectModal";
import LinkedInIntegrationAuthorizeModal from "./LinkedInIntegrationAuthorizeModal";
import LinkedInIntegrationErrorModal from "./LinkedInIntegrationErrorModal";

// eslint-disable-next-line react/prefer-stateless-function
export class LoginPage extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      expiredToken: false,
      idPLoggingIn: false,
      rememberMe: false,
      showLoginUpdateNotification: false,
      showRegionSelectModal: false,
      region: "US & North America",
      liOnboarding: false,
    };
  }

  UNSAFE_componentWillMount() {
    const queryParams = queryString.parse(window.location.search);

    const verifyToken =
      window.location.pathname === "/verifyAccount" && queryParams.verifyToken;

    if (
      window.location.pathname === "/liOnboarding" &&
      queryParams.extensionType &&
      queryParams.hiringContext &&
      queryParams.redirectUrl &&
      queryParams.signature
    ) {
      this.setState({ liOnboarding: true });
    }

    try {
      const token = this.props.tk2
        ? jwtDecode(this.props.tk2)
        : jwtDecode(verifyToken);

      const isExpired = token.exp <= Math.floor(Date.now() / 1000);

      this.setState({ expiredToken: isExpired });
    } catch (e) {
      this.setState({ expiredToken: false });
    }

    // SSO redirect handling
    if (
      queryParams.code &&
      queryParams.state &&
      decodeURIComponent(queryParams.state.replace(/\s/, "+")) ===
        decodeURIComponent(sessionStorage.getItem("logState"))
    ) {
      this.setState({ idPLoggingIn: true });
      const redirectToPostHireSSO = sessionStorage.getItem(
        "redirectToPosthireSSO"
      );
      this.props.onSSOLogin(
        queryParams.code,
        sessionStorage.getItem("logVerif"),
        this.state.rememberMe || sessionStorage.getItem("rememberMe") === "true"
          ? 1
          : 0,
        !!redirectToPostHireSSO
        // window.location.pathname.split('/')[2] === 'auth0'
      );
    }

    // SSO/updated login page notification logic:
    if (!getCookieValue(document.cookie, "loginUpdateNotified")) {
      document.cookie = "loginUpdateNotified=true";
      this.setState({
        showLoginUpdateNotification: true,
      });
    } else {
      this.setState({
        showLoginUpdateNotification: false,
      });
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (
      this.state.idPLoggingIn &&
      ((nextProps.ssoError !== this.props.ssoError &&
        nextProps.ssoError !== null) ||
        (nextProps.errorCode !== this.props.errorCode &&
          nextProps.errorCode !== null))
    ) {
      this.setState({ idPLoggingIn: false });
    }
  }

  setRememberMe = (rememberBool) => {
    this.setState({ rememberMe: rememberBool });
  };

  handleShowRegionSelectModal = () => {
    this.setState({ showRegionSelectModal: true });
  };

  handleHideRegionSelectModal = () => {
    this.setState({
      showRegionSelectModal: false,
      region: "US & North America",
    });
  };

  handleRegionSelectOnChange = (event) => {
    switch (event) {
      case "asiaPacific":
        this.setState({ region: "Asia-Pacific" });
        break;
      case "centralSouthAmerica":
        this.setState({ region: "Central & South America" });
        break;
      case "europeUK":
        this.setState({ region: "Europe & the UK" });
        break;
      case "middleEastNorthernAfrica":
        this.setState({ region: "Middle-east & Northern Africa" });
        break;
      case "southernAfrica":
        this.setState({ region: "Southern Africa" });
        break;
      case "usNorthAmerica":
        this.setState({ region: "US & North America" });
        break;
      default:
        this.setState({ region: "US & North America" });
        break;
    }
  };

  render() {
    const { showUserVerified, tk1, tk2, resetPassword } = this.props;
    /*
      ? Sets status based on whether it is a new login, setting a new password, had the password reset, or if the link
      ? is expired.
      ? Component to Display is then set dependent on the status.
      ? Is this the best way to this without using nested ternary statements?
    */

    const queryParams = queryString.parse(window.location.search);

    const verifyToken =
      window.location.pathname === "/verifyAccount" && queryParams.verifyToken;

    let status = null;

    if (verifyToken && !this.state.expiredToken) {
      status = "verify";
    } else if (tk1 && tk2) {
      status = "reset";
    } else if (resetPassword) {
      status = "passwordReset";
    } else if (this.state.expiredToken) {
      status = "expired";
    }

    const isAU = getSubDomain() === "app-au";

    const showInvalidVerifyLink =
      window.location.pathname === "/verifyAccount" && status === "expired";

    const helmetTitle =
      verifyToken && !showInvalidVerifyLink ? "Create password" : "Login";

    const showSwitchInstanceLink =
      !verifyToken || (verifyToken && showUserVerified);

    return (
      <div>
        <Helmet
          title={`${helmetTitle} - Criteria`}
          meta={[{ name: "description", content: "Description of Login" }]}
        />
        <Row className="mx-0">
          <Col
            lg={4}
            md={12}
            sm={12}
            className={`loginLeftPanel ${isAU ? "au" : ""} d-none d-lg-block`}
          >
            <table>
              <tbody>
                <tr>
                  <td className="align-middle">
                    <img
                      src={isAU ? CriteriaBlueLogo : CriteriaLogo}
                      alt="Criteria"
                    />
                  </td>
                </tr>
              </tbody>
            </table>
          </Col>
          {this.state.idPLoggingIn ? (
            <div style={{ margin: "auto" }}>
              <Loader
                show={this.state.idPLoggingIn}
                message={
                  <span>
                    <p
                      className="d-inline-block"
                      style={{
                        fontSize: "20px",
                        color: "black",
                        marginRight: "14px",
                      }}
                    >
                      Please wait
                    </p>
                    <ThreeBounce color="#1F469A" size={15} />
                  </span>
                }
                contentBlur={30}
                backgroundStyle={{
                  backgroundColor: "rgba( 0 0 0 0)",
                  position: "relative",
                  paddingBottom: "25px",
                  paddingTop: "25px",
                }}
              />
            </div>
          ) : (
            <Col className="loginRightPanel" lg={8} md={12} sm={12}>
              <Row className="pt-1 px-1 flex-nowrap">
                <Col lg={6} md={6} sm={6}>
                  <div className="d-block d-lg-none">
                    <img
                      src={CriteriaBlueLogoSmall}
                      alt="Criteria"
                      className="criteria-logo-small"
                    />
                  </div>
                </Col>
                <Col lg={6} md={6} sm={6}>
                  <p className="mt-3 text-right">
                    New to Criteria?{" "}
                    <Button
                      variant="primary"
                      className="tryForFreeButton"
                      onClick={this.handleShowRegionSelectModal}
                    >
                      Try for Free
                    </Button>
                  </p>
                </Col>
              </Row>
              <Row className="px-5">
                <Col>
                  <LoginForm
                    errorCode={this.props.errorCode}
                    expiredToken={this.state.expiredToken}
                    status={status}
                    tk1={this.props.tk1}
                    tk2={this.props.tk2}
                    rememberMe={this.state.rememberMe}
                    setRememberMe={this.setRememberMe}
                    showLoginUpdateNotification={
                      this.state.showLoginUpdateNotification
                    }
                    liOnboarding={this.state.liOnboarding}
                    showInvalidVerifyLink={showInvalidVerifyLink}
                  />
                </Col>
              </Row>

              <Row>
                <Col className="loginPageFooter">
                  {showSwitchInstanceLink ? (
                    <a
                      href={
                        isAU
                          ? "https://hireselect.criteriacorp.com"
                          : "https://app-au.criteriacorp.com"
                      }
                      className="mb-3"
                    >
                      Switch to {isAU ? "North America" : "APAC"} instance
                    </a>
                  ) : null}
                  <span>
                    Copyright &copy; 2005-{new Date().getFullYear()}, Criteria
                    Corp. All Rights Reserved. |{" "}
                    <OverlayTrigger
                      placement="top"
                      overlay={
                        <Popover
                          id="copyrightPopover"
                          style={{
                            padding: "5px 10px",
                          }}
                        >
                          On-Demand Assessment&trade; and Criteria Corp&trade;
                          are trademarks of Criteria Corp. MRAB copyright
                          &copy;2006 Harvard University (patent pending) is
                          licensed exclusively by Criteria Corp.
                        </Popover>
                      }
                    >
                      <span className="copyright">Copyright Notices</span>
                    </OverlayTrigger>{" "}
                    |{" "}
                    <a
                      href="https://www.criteriacorp.com/terms-use"
                      target="_blank"
                    >
                      Terms of Use
                    </a>{" "}
                    |{" "}
                    <a
                      href="https://www.criteriacorp.com/privacy-policy"
                      target="_blank"
                    >
                      Privacy Policy
                    </a>{" "}
                    | <a href="/partners">Partner Login</a>
                  </span>
                </Col>
              </Row>
            </Col>
          )}
          <RegionSelectModal
            showRegionSelectModal={this.state.showRegionSelectModal}
            handleShowRegionSelectModal={this.handleShowRegionSelectModal}
            handleHideRegionSelectModal={this.handleHideRegionSelectModal}
            handleRegionSelectOnChange={this.handleRegionSelectOnChange}
            region={this.state.region}
          />
          {this.state.liOnboarding &&
            this.props.showLinkedInIntegrationErrorModal && (
              <LinkedInIntegrationErrorModal
                showLinkedInIntegrationErrorModal={
                  this.props.showLinkedInIntegrationErrorModal
                }
                linkedInIntegrationErrorMessage={
                  this.props.linkedInIntegrationErrorMessage
                }
                linkedInUserEmail={this.props.linkedInUserEmail}
                loginToken={this.props.loginToken}
              />
            )}
          {this.state.liOnboarding && this.props.showLinkedInAuthorizeModal && (
            <LinkedInIntegrationAuthorizeModal
              liOnboarding={this.state.liOnboarding}
              showLinkedInAuthorizeModal={this.props.showLinkedInAuthorizeModal}
              onAuthorizeLinkedInIntegration={
                this.props.onAuthorizeLinkedInIntegration
              }
              linkedInUserEmail={this.props.linkedInUserEmail}
              loginToken={this.props.loginToken}
            />
          )}
        </Row>
      </div>
    );
  }
}

LoginPage.propTypes = {
  tk1: string,
  tk2: string,
  errorCode: number,
  resetPassword: bool.isRequired,
  onSSOLogin: func.isRequired,
  ssoError: object,
  linkedInUserEmail: string,
  showLinkedInAuthorizeModal: bool,
  onAuthorizeLinkedInIntegration: func,
  linkedInIntegrationErrorMessage: string,
  showLinkedInIntegrationErrorModal: bool,
  loginToken: string,
  showUserVerified: bool,
};

const mapStateToProps = (state) => ({
  errorCode: state.get("App").get("errorCode"),
  ssoError: state.get("App").get("ssoError"),
  resetPassword: state.get("App").get("resetPassword"),
  linkedInUserEmail: state.get("App").get("linkedInUserEmail"),
  showLinkedInAuthorizeModal: state
    .get("App")
    .get("showLinkedInAuthorizeModal"),
  linkedInIntegrationErrorMessage: state
    .get("App")
    .get("linkedInIntegrationErrorMessage"),
  showLinkedInIntegrationErrorModal: state
    .get("App")
    .get("showLinkedInIntegrationErrorModal"),
  loginToken: state.get("App").get("loginToken"),
  showUserVerified: state.get("App").get("showUserVerified"),
});

export function mapDispatchToProps(dispatch) {
  return {
    onSSOLogin: (
      authorizationCode,
      codeVerifier,
      rememberMe /* isAuth0 */,
      isPostHireLogin
    ) =>
      dispatch(
        ssoLogin(
          authorizationCode,
          codeVerifier,
          rememberMe /* isAuth0 */,
          isPostHireLogin
        )
      ),
    onAuthorizeLinkedInIntegration: (token, userEmail, liIntegrationData) =>
      dispatch(
        authorizeLinkedInIntegration(token, userEmail, liIntegrationData)
      ),
    dispatch,
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(LoginPage);
